module.exports = __webpack_public_path__ + "img/47.952fbe24.svg";